import styled from 'styled-components';
import { fromBreakpoint, TABLET } from '../../../../mediaqueries';

export const OverlayContent = styled.div`
    padding: 0 15px 20px;

    ${fromBreakpoint[TABLET]`
        padding: 0 30px 30px;           
    `}
`;
